import axios from 'axios'
import Vue from 'vue'
let axiosAccess = axios.create({
    baseURL: 'https://apodaca.rciempaquesplegadizos.com:8180/',
    
    headers: {
        
        'Content-Type': 'application/json',
       
      },
  })

export async function fetchDia (context,payload){
    try{
    let url = "access/filtroof/_por_dia"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushDatos')//se limpia el state
    let values = new FormData()
    values.append('dia',payload.dia)  
    values.append('dia2',payload.dia2)
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setDatos',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}

export async function fetchOf(context,payload){
    try{
        let url = "access/filtroof/_por_of"//la direccion de la api
        context.commit('setLoading',true,{root:true})
        context.commit('flushDatos')//se limpia el state
        let values = new FormData()
        values.append('orden',payload.orden)
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosAccess({
            method: 'POST',
            url: url,
            data: values
        })
        context.commit('setDatos',response.data.data)
    }catch(error){
        context.commit('setError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
    
}